//Get url parameters

import React, { useEffect, useState } from "react";

const kartenBeschreibung = {
    Mittagskarte: {
        subheading: "",
        description:
            "Alle Gerichte werden mit Salat und Beilage nach Wunsch serviert. Beilagen: Pommes, Reis, Kroketten, Kartoffelchips, Bandnudeln",
    },
    Weinkarte: {
        subheading: "",
        description:
            "Genießen Sie unsere Auswahl an Weinen aus der Region und aus aller Welt.",
    },
    Speisekarte: {
        subheading: "",
        description:
            "Alle Gerichte werden mit Salat und Beilage nach Wunsch serviert. Beilagen: Pommes, Reis, Kroketten, Kartoffelchips, Bandnudeln",
    },
    default: {
        subheading: "",
        description: "",
    },
};

const getMittagskarteSubheading = () => {
    const currentMonth = new Date().getMonth() + 1;
    const isSummer = currentMonth >= 4 && currentMonth <= 9;

    return isSummer
        ? "Sommer (April bis September): Dienstag bis Samstag von 11:30 bis 14:00 Uhr"
        : "Winter (Oktober bis März): Mittwoch bis Freitag von 11:30 bis 14:00 Uhr";
};

const getKartenBeschreibung = (menuName) => {
    if (menuName === "Mittagskarte") {
        return {
            ...kartenBeschreibung.Mittagskarte,
            subheading: getMittagskarteSubheading(),
        };
    }

    return kartenBeschreibung[menuName] || kartenBeschreibung.default;
};

const Karte = () => {
    // Get the menu name from the URL
    const url = window.location.href;
    var menuParameter = url.split("?").pop();
    const [menuName, setMenuName] = useState(menuParameter);
    const [categories, setCategories] = useState([]);
    const [items, setItems] = useState([]);

    const [expandedCategory, setExpandedCategory] = useState(null);

    const toggleCategory = (categoryId) => {
        setExpandedCategory((prev) =>
            prev === categoryId ? null : categoryId,
        );
    };

    // Fetch categories and items from the backend
    const fetchMenu = async () => {
        try {
            const response = await fetch(`/api/public/menus/name/${menuName}`);
            const data = await response.json();
            if (response.ok) {
                setCategories(data.categories);
                setItems(data.items);
            } else {
                setMenuName("Speisekarte nicht gefunden");
            }
        } catch (error) {
            console.error("Fehler beim Laden der Speisekarte:", error);
        }
    };

    useEffect(() => {
        fetchMenu();
    }, []);

    return (
        <>
            <div className="max-w-7xl mx-auto p-4 my-16 bg-white">
                <div className="flex flex-row justify-center items-center space-x-4 flex-wrap">
                    <h1 className="text-3xl font-bold text-center text-black mt-3">
                        {menuName}
                    </h1>
                    <a
                        href={`/documents/${menuName}.pdf`}
                        target="_blank"
                        rel="noreferrer"
                        className="bg-transparent border-enedemgreen border-2 text-enedemgreen px-2 py-1 rounded-md hover:bg-green-800 hover:text-white"
                    >
                        Als PDF
                    </a>
                </div>

                <p className="text-md md:text-lg text-black font-bold text-center mt-4">
                    {getKartenBeschreibung(menuName).subheading}
                </p>
                <p className="text-md md:text-lg text-gray-700 text-center">
                    {getKartenBeschreibung(menuName).description}
                </p>
                <div className="min-h-96 mt-8">
                    {categories.length > 1 ? (
                        categories.map((category) => (
                            <div key={category._id} className="pb-4">
                                <button
                                    onClick={() => toggleCategory(category._id)}
                                    className="w-full text-left flex justify-between items-center py-2 px-4 text-lg font-semibold bg-gray-100 hover:bg-gray-200 rounded-md"
                                >
                                    <span>{category.title}</span>
                                    <span>
                                        {expandedCategory === category._id
                                            ? "▲"
                                            : "▼"}
                                    </span>
                                </button>
                                {expandedCategory === category._id && (
                                    <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-2">
                                        {items
                                            .filter(
                                                (item) =>
                                                    item.category ===
                                                    category._id,
                                            )
                                            .map((item) => (
                                                <div
                                                    key={item._id}
                                                    className="flex flex-row bg-white p-2 mx-2 border-b"
                                                >
                                                    {/* Left Section: Title and Description */}
                                                    <div className="flex-1 pr-4">
                                                        <h3 className="text-sm md:text-md font-semibold text-black">
                                                            {item.title}
                                                        </h3>
                                                        <p className="italic text-gray-700 text-sm md:text-md">
                                                            {item.description}
                                                        </p>
                                                    </div>
                                                    {/* Right Section: Prices */}
                                                    <div className="flex-none">
                                                        <ul className="">
                                                            {item.prices.map(
                                                                (
                                                                    price,
                                                                    index,
                                                                ) => (
                                                                    <li
                                                                        key={
                                                                            index
                                                                        }
                                                                        className="flex justify-between text-black space-x-2"
                                                                    >
                                                                        <span className="text-sm md:text-md">
                                                                            {
                                                                                price.description
                                                                            }
                                                                        </span>
                                                                        <span className="text-sm md:text-md font-bold">
                                                                            {price.amount.toFixed(
                                                                                2,
                                                                            )}{" "}
                                                                            €
                                                                        </span>
                                                                    </li>
                                                                ),
                                                            )}
                                                        </ul>
                                                    </div>
                                                </div>
                                            ))}
                                    </div>
                                )}
                            </div>
                        ))
                    ) : (
                        <div>
                            <div className="mt-4 grid grid-cols-1 md:grid-cols-2">
                                {items.map((item) => (
                                    <div
                                        key={item._id}
                                        className="flex flex-row bg-white p-2 mx-2 border-b"
                                    >
                                        {/* Left Section: Title and Description */}
                                        <div className="flex-1 pr-4">
                                            <h3 className="text-sm md:text-md font-semibold text-black">
                                                {item.title}
                                            </h3>
                                            <p className="italic text-gray-700 text-sm md:text-md">
                                                {item.description}
                                            </p>
                                        </div>
                                        {/* Right Section: Prices */}
                                        <div className="flex-none">
                                            <ul className="">
                                                {item.prices.map(
                                                    (price, index) => (
                                                        <li
                                                            key={index}
                                                            className="flex justify-between text-black space-x-2"
                                                        >
                                                            <span className="text-sm text-md">
                                                                {
                                                                    price.description
                                                                }
                                                            </span>
                                                            <span className="text-sm md:text-md font-bold">
                                                                {price.amount.toFixed(
                                                                    2,
                                                                )}{" "}
                                                                €
                                                            </span>
                                                        </li>
                                                    ),
                                                )}
                                            </ul>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
                {/* Button for pdf download */}
            </div>
        </>
    );
};

export default Karte;
